

























import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, ViewModes } from '@/ts/store/Constants';
import PersonData from '@/ts/PersonData';
import VueClickOutside from 'v-click-outside';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

@Component({
    directives: {
        clickOutside: VueClickOutside.directive,
    },
})
export default class PersonSuggestions extends Mixins(DeviceMethods) {
    public searchQuery: string = '';
    public suggestionsReady: boolean = false;
    public currentlyHovered: number | null = null;
    public visible: boolean = false;

    constructor() {
        super();
    }

    get personSuggestions(): PersonData[] {
        const returnData: PersonData[] = [];

        if (!this.dataLoaded) {
            return returnData;
        }

        const baseData = this.$store.getters['User/getPersonSuggestions'];
        const currentParticipants = this.$store.getters['Messages/currentParticipants'];

        for (const userId of baseData) {
            if (!currentParticipants.includes(userId)) {
                returnData.push(this.getUser(userId));
            }
        }

        return returnData;
    }

    get dataLoaded(): boolean {
        return (
            this.$store.getters['Messages/activeConversation'] !== null
         && this.$store.getters['Messages/currentParticipants']
        );
    }

    public personHover(index: number) {
        if (this.desktopLayout) {
            this.currentlyHovered = index;
        }
    }

    public clearHover() {
        this.currentlyHovered = null;
    }

    public itemClasses(index: number) {
        return {
            'hococo-person-suggestion-hover': (index === this.currentlyHovered),
            'hococo-person-suggestion-adjacent': (
                this.currentlyHovered !== null && index === this.currentlyHovered - 1
            ),
        };
    }

    public queryRecipients(): void {
        this.$store.dispatch(Actions.QUERY_PERSON_SUGGESTIONS, this.searchQuery);
    }

    public selectPerson(userId: number): void {
        // this.$store.dispatch(Actions.ADD_PERSON_TO_CONVERSATION, userId);

        if (this.mobileLayout) {
            this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Messages);
        }
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }
}
